import { apiV1 } from "@/store";

const actions = {
  getAllCallTypes: () => {
    return new Promise((resolve, reject) => {
      apiV1.get(`/call-types`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  submitCallType: ({ dispatch }, callType) => {
    return new Promise((resolve, reject) => {
      apiV1.post(`/call-types`, callType)
        .then((resp) => {
          dispatch("handleSuccess", "Call type added!");
          dispatch("getAllDispositions");
          resolve(resp);
        })
        .catch((err) => {
          dispatch("handleError", err);
          reject(err);
        });
    });
  },

  updateCallType: ({ dispatch }, callType) => {
    return new Promise((resolve, reject) => {
      apiV1.patch(`/call-types/${callType.id}`, callType)
        .then((resp) => {
          dispatch("handleSuccess", "Call type updated!");
          resolve(resp);
        })
        .catch((err) => {
          dispatch("handleError", err);
          reject(err);
        });
    });
  },

  getAllDispositions: ({}, status) => {
    let value = !status ? 0 : status;
    return new Promise((resolve, reject) => {
      apiV1.get(`/dispositions?enabled=${value}`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  submitDisposition: ({ dispatch }, disposition) => {
    return new Promise((resolve, reject) => {
      apiV1.post(`/dispositions`, disposition)
        .then((resp) => {
          dispatch("handleSuccess", "Disposition type added!");
          dispatch("getAllDispositions");
          resolve(resp);
        })
        .catch((err) => {
          dispatch("handleError", err);
          reject(err);
        });
    });
  },

  updateDisposition: ({ dispatch }, disposition) => {
    return new Promise((resolve, reject) => {
      apiV1.patch(`/dispositions/${disposition.id}`, disposition)
        .then((resp) => {
          dispatch("handleSuccess", "Disposition updated!");
          resolve(resp);
        })
        .catch((err) => {
          dispatch("handleError", err);
          reject(err);
        });
    });
  }
};

export default {
  actions
};
